<template>
  <div class="login-container">
    <el-card class="login-card">
      <!-- لوگو یا عنوان -->
      <div class="logo-wrapper">
        <img src="/logo5-green.png" alt="لوگو" class="logo" />
        <h3>ورود به حساب کاربری</h3>
      </div>

      <el-form @submit.prevent="submitLogin" :model="form" label-position="top">
        <!-- موبایل -->
        <el-form-item label="تلفن همراه">
          <el-input
            v-model="form.mobile"
            clearable
            inputmode="numeric"
            pattern="[0-9]*"
            @keypress="numericKeypress"
            @input="(val) => (form.mobile = val.replace(/\D/g, ''))"
            placeholder="شماره تلفن همراه خود را وارد کنید"
          />
        </el-form-item>

        <!-- پسورد با نمایش/عدم‌نمایش -->
        <el-form-item label="گذرواژه">
          <el-input
            v-model="form.password"
            show-password
            placeholder="گذرواژه خود را وارد کنید"
            autocomplete="off"
            @keyup.enter="submitLogin"
            @keypress="passwordKeypress"
          >
          </el-input>
        </el-form-item>

        <!-- پیام خطا -->
        <div v-if="auth.error" class="error-message">
          {{ auth.error }}
        </div>

        <!-- دکمه ورود -->
        <el-button
          type="primary"
          style="width: 100%; margin-top: 1rem"
          native-type="submit"
          :loading="auth.loading"
        >
          ورود
        </el-button>

        <!-- لینک فراموشی رمز عبور -->
        <div class="forgot-password">
          <el-link type="primary" @click="goToForgotPassword">
            فراموشی رمز عبور؟ </el-link
          ><br />
          <el-link @click="goToRegister"> ثبت نام </el-link>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useRouter } from "vue-router";
import { showToast } from "@/utils/toastHelper";
import { passwordKeypress, numericKeypress } from "@/utils/validateInput";

const auth = useAuthStore();
const router = useRouter();

const form = ref({
  mobile: "",
  password: "",
});

const submitLogin = async () => {
  let validation = true;
  let message = "";

  if (form.value.password.length < 10) {
    validation = false;
    message += "حداقل طول رمز باید 10 کاراکتر باشد";
  }

  if (form.value.mobile.length !== 11) {
    validation = false;
    message += message ? "<br>" : "";
    message += "شماره موبایل باید 11 رقم باشد";
  }

  if (!validation) {
    showToast(message, "error");
    return;
  }

  try {
    await auth.loginUser({ ...form.value });

    if (auth.isLoggedIn) {
      router.push("/area");
    }
  } catch (error) {
    if (error.response?.data?.message) {
      showToast(error.response.data.message, "error");
    } else {
      showToast("خطای نامشخصی رخ داده است.", "error");
    }
  }
};

const goToForgotPassword = () => {
  router.push("/forgot-password");
};
const goToRegister = () => {
  router.push("/register");
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.login-card {
  width: 450px;
  padding: 2rem;
  background: #f9fbfd;
  border-radius: 20px;
}

.logo-wrapper {
  text-align: center;
  margin-bottom: 1.5rem;
}

.logo {
   width: 200px;
  height: 100px;
  margin-bottom: 0.5rem;
}

.error-message {
  color: red;
  margin-bottom: 1rem;
  text-align: center;
}

.forgot-password {
  text-align: center;
  margin-top: 1rem;
  font-weight: 500;
}
.forgot-password a {
  color: #052956;
  font-weight: 600;
  margin-top: 10px;
}
.clickable {
  cursor: pointer;
  font-size: 20px;
}
</style>
